import { Product } from '@features/product/components/Collection/Collection.types';
import { AvailabilityState } from '@features/product/typings';

export default function getFirstAvailableCollectionProduct(
  products: (Product | null)[] | undefined
): Product | null | undefined {
  return (
    products &&
    products.find(
      product =>
        product !== null &&
        product !== undefined &&
        product.urls !== null &&
        product.mediaGallery !== null &&
        product.nullableAvailabilityState &&
        product?.nullableAvailabilityState !== AvailabilityState.OutOfStock &&
        product?.nullableAvailabilityState !== AvailabilityState.TemporaryOutOfStock
    )
  );
}
